var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.506,
    height: 14.07,
    viewBox: "0 0 12.506 14.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Delete",
    transform: "translate(-111.235 -369.931)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "delete_FILL1_wght400_GRAD0_opsz48",
    d: "M9.974,20.07A1.2,1.2,0,0,1,8.8,18.9V7.759H8V6.586h3.674V6h5.159v.586h3.674V7.759h-.8V18.9a1.2,1.2,0,0,1-1.172,1.172Zm2.071-2.853h1.172V9.42H12.045Zm3.244,0h1.172V9.42H15.289Z",
    transform: "translate(103.235 363.931)",
    fill: "#9eabb0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.1456a9133e90225fee78b23aeefc72c8.svg";
export { ForwardRef as ReactComponent };